import { useEffect, useState } from "react";
import { CheckCircle2, Clock, XCircle, BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = {
  done: ["COMPLETED", "bg-[#0d3d30] text-[#10B981]", CheckCircle2],
  paid: ["PAID", "bg-[#0d3d30] text-[#10B981]", CheckCircle2],
  approved: ["APPROVED", "bg-[#13304f] text-[#4DA3FF]", BadgeCheck],
  pending: ["PENDING", "bg-[#40371c] text-[#F5A524]", Clock],
  rejected: ["REJECTED", "bg-[#3d1424] text-[#EF4444]", XCircle],
};

export const StatusBadge = ({ s }) => {
  const [l, c, I] = STATUS[s] || STATUS.pending;
  return <span data-testid={`status-badge-${s}`} className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-black ${c}`}><I size={13} />{l}</span>;
};

const fmtDate = (s) => { const d = new Date(s); return `${d.toLocaleDateString()}, ${d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}`; };

function Row({ t }) {
  const isP = t.type === "purchase";
  return (
    <div data-testid={`history-row-${t.id}`} className="flex items-start justify-between gap-3 py-4 border-b border-white/5 last:border-0">
      <div className="min-w-0">
        <div className="font-bold text-white">{isP ? "Coin Purchase" : "Redemption"}</div>
        <div className="mt-0.5 text-sm text-gray-300">
          {isP ? <>{t.gc.toLocaleString()} GC + {t.sc.toFixed(2)} SC</> : t.destination}
        </div>
        <div className="mt-1 text-xs text-gray-500 truncate">{fmtDate(t.created_at)} · {t.ref || t.payout_ref || t.id.slice(0, 8).toUpperCase()}</div>
      </div>
      <div className="text-right shrink-0">
        <div className="font-display font-black text-white">${t.amount.toFixed(2)}</div>
        <div className="mt-1"><StatusBadge s={t.status} /></div>
      </div>
    </div>
  );
}

export function HistoryTab() {
  const [type, setType] = useState("purchase");
  const [rows, setRows] = useState(null);
  useEffect(() => { setRows(null); api.get(`/store/history?type=${type}`).then((r) => setRows(r.data)); }, [type]);

  return (
    <div data-testid="history-tab">
      <div className="flex rounded-xl bg-[#0B0E14] border border-white/5 p-1 text-sm">
        {[["purchase", "Purchases"], ["redeem", "Redemptions"]].map(([k, l]) => (
          <button key={k} data-testid={`history-filter-${k}`} onClick={() => setType(k)} className={`flex-1 rounded-lg py-2.5 font-bold transition-colors ${type === k ? "bg-[#13304f] text-[#9db6ff]" : "text-gray-500"}`}>{l} {rows && type === k ? `(${rows.length})` : ""}</button>
        ))}
      </div>
      <div className="mt-3 rounded-2xl bg-[#1F2633] border border-white/5 px-4">
        {rows === null && <div className="text-gray-500 text-sm py-6">Loading…</div>}
        {rows?.length === 0 && <div className="text-gray-500 text-sm py-10 text-center" data-testid="history-empty">No {type} history yet.</div>}
        {rows?.map((t) => <Row key={t.id} t={t} />)}
      </div>
    </div>
  );
}
